import React, { useEffect, useState } from 'react';
import axiosInstance from "../../../api/api";
import { Row, Col, Card, Spinner, Button, ButtonGroup, Form, InputGroup } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import CiemModal from "./CiemModal";
import { useDispatch } from "react-redux";
import { setId } from "../../../redux/ciemSlice";
import { Routes } from "../../../routes";
import { useHistory } from "react-router-dom";

const CiemList = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [searchFilter, setSearchFilter] = useState('');
    const [portadaImages, setPortadaImages] = useState({});
    const dispatch = useDispatch();
    const navigate = useHistory();


    const loadPortadaImage = async (code) => {
        try {
            const response = await axiosInstance.get(`/ciem/portada/${code}`, {
                responseType: 'blob'
            });
            const imageUrl = URL.createObjectURL(response.data);
            return imageUrl;
        } catch (error) {
            console.log(`No portada found for code: ${code}`);
            return null;
        }
    };

    const fetchCiem = async () => {
        try {
            const params = {};
            if (searchFilter) params.filter = searchFilter;

            const response = await axiosInstance.get('/ciem/', { params });
            const ciemItems = response.data.data;
            setItems(ciemItems);
            console.log(ciemItems);

            // Load portada images for all items
            const imagePromises = ciemItems.map(async (item) => {
                if (item.code) {
                    const imageUrl = await loadPortadaImage(item.code);
                    return { code: item.code, url: imageUrl };
                }
                return null;
            });

            const imageResults = await Promise.all(imagePromises);
            const imageMap = {};
            imageResults.forEach(result => {
                if (result && result.url) {
                    imageMap[result.code] = result.url;
                }
            });
            setPortadaImages(imageMap);
        } catch (error) {
            console.log(error.message);
        }
    };

    // Manejar la creación o edición de un elemento
    const handleSubmit = (data) => {
        if (selectedItem) {
            data.id = selectedItem.id
            // Lógica para editar
            axiosInstance.post('/ciem/', data).then(async (response) => {
                // Si hay una imagen, la subimos
                if (data.image) {
                    try {
                        const updatedItem = response.data.data;
                        const code = updatedItem.code || selectedItem.code;
                        const name = updatedItem.name || data.name;

                        if (code && name) {
                            const formData = new FormData();
                            formData.append('file', data.image);

                            await axiosInstance.post(`/ciem/uploadPortada/${code}/${name}`, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            });
                        } else {
                            console.warn("No se pudo obtener el código o nombre para subir la imagen.");
                        }

                    } catch (uploadError) {
                        console.error('Error subiendo imagen:', uploadError);
                        alert("Los datos se actualizaron, pero hubo un error subiendo la imagen: " + (uploadError.response?.data?.message || uploadError.message));
                    }
                }

                alert("Datos actualizados correctamente");
                setLoading(false);
                // Actualizar el estado del componente con los datos actualizados
                fetchCiem();
            }).catch(error => {
                console.error('Error guardando data:', error);
                setLoading(false);
            });
        } else {
            // Lógica para crear
            // Lógica para crear
            axiosInstance.post('/ciem/', data).then(async (response) => {
                // Si hay una imagen, la subimos
                if (data.image) {
                    try {
                        const createdItem = response.data.data; // Asumiendo que el backend devuelve el objeto creado en data.data
                        // Si el backend no devuelve el objeto completo, necesitaremos usar los datos que enviamos o hacer un fetch
                        // Por seguridad, verificamos si tenemos code y name. Si no, quizas el backend los genera y los devuelve.
                        const code = createdItem.code;
                        const name = createdItem.name;

                        if (code && name) {
                            const formData = new FormData();
                            formData.append('file', data.image);

                            await axiosInstance.post(`/ciem/uploadPortada/${code}/${name}`, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            });
                        } else {
                            console.warn("No se pudo obtener el código o nombre para subir la imagen.");
                        }

                    } catch (uploadError) {
                        console.error('Error subiendo imagen:', uploadError);
                        alert("La idea de negocio se creó, pero hubo un error subiendo la imagen: " + (uploadError.response?.data?.message || uploadError.message));
                    }
                }

                alert("Datos actualizados correctamente");
                setLoading(false);
                // Actualizar el estado del componente con los datos actualizados
                fetchCiem();
            }).catch(error => {
                const errorMessage = error.response?.data?.message || error.message;
                alert("Ocurrio el siguiente error -> " + errorMessage);
                console.error('Error guardando data:', error);
                setLoading(false);
            });
        }
        setShowModal(false);
        setSelectedItem(null);
    };

    const handleModificarIdeaNegocio = (id) => {
        console.log("entro a modificar" + id)
        dispatch(setId(id));
        navigate.push(Routes.ListTeamPage.path);
    };

    // Manejar la eliminación de un elemento
    const handleDelete = (id) => {

        const confirmDelete = window.confirm(`¿Estás seguro de eliminar el registro con ID: ${id}?`);
        if (confirmDelete) {
            axiosInstance.delete('/ciem/' + id).then(response => {
                alert(`Registro con ID: ${id} eliminado`);
                setLoading(false);
                // Actualizar el estado del componente con los datos actualizados
                fetchCiem();
            }).catch(error => {
                alert("Ocurrio el siguiente error -> " + error.response.data.message);
                console.error('Error guardando data:', error.response.data.message);
                setLoading(false);
            });
        }
        //logica para eliminar

    };

    useEffect(() => {
        fetchCiem();

        return () => {
            Object.values(portadaImages).forEach(url => {
                if (url && url.startsWith('blob:')) {
                    URL.revokeObjectURL(url);
                }
            });
        };
    }, []);


    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0 w-100">
                    <Form onSubmit={(e) => { e.preventDefault(); fetchCiem(); }}>
                        <Row>
                            <Col md={10} className="mb-3 mb-md-0">
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon={faSearch} />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="text"
                                        placeholder="Buscar idea de negocio..."
                                        value={searchFilter}
                                        onChange={(e) => setSearchFilter(e.target.value)}
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={2}>
                                <Button variant="primary" type="submit" className="w-100">
                                    Buscar
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>

            <Row>
                {/* Card para "Crear nuevo" */}
                <Col md={4} className="mb-4">
                    <Card className="h-100">
                        <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                            <Card.Title>Crear nueva idea de negocio</Card.Title>
                            <Button variant="primary" size="lg" onClick={() => setShowModal(true)}>
                                +
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Cards obtenidas de la API */}
                {items.map(item => (
                    <Col key={item.id} md={4} className="mb-4">
                        <Card className="h-100">
                            {/* Imagen en la parte superior */}
                            <Card.Img
                                variant="top"
                                src={portadaImages[item.code] || `https://picsum.photos/300/200?random=${item.id}`}
                                alt="Imagen de la card"
                            />
                            <Card.Body className="d-flex flex-column">
                                <Card.Title>{item.name}</Card.Title>
                                <Card.Text>{item.description}</Card.Text>
                                {/* Botones en la parte inferior */}
                                <div className="mt-auto d-flex justify-content-between">
                                    <ButtonGroup size="sm">
                                        <Button variant="primary" size="sm" onClick={() =>
                                            handleModificarIdeaNegocio(item.id)}>
                                            Modificar idea de negocio
                                        </Button>
                                        <Button variant="warning" size="sm" onClick={() => {
                                            setSelectedItem(item);
                                            setShowModal(true);
                                        }}>
                                            Editar Titulo
                                        </Button>
                                        <Button variant="danger" size="sm" onClick={() => handleDelete(item.id)}>
                                            Eliminar
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}

                {/* Modal para crear/editar */}
                <CiemModal
                    show={showModal}
                    onHide={() => {
                        setShowModal(false);
                        setSelectedItem(null);
                    }}
                    onSubmit={handleSubmit}
                    initialData={selectedItem || {}}
                />
            </Row>
        </>
    );
};

export default CiemList;
